import React, { Fragment, FunctionComponent, useContext, useState } from 'react';
import { useForm } from 'react-hook-form';
import { FormContext } from '../../../../../../context';
import {
  StepperContent,
  StepperHeader,
  StepperSubmit
} from '../../../../../shared/general/stepper';
import { getDefaultValuesStep1 } from '../../utils/calculators-student-loan-utils';
import { FormElementDynamicInputTyped } from '../../../../../shared/form-elements';
import { CalculatorsStudentLoanStep1FormFields } from '../../../../../../@types/features/calculators';
import { calculatorStudentLoanStep1FormFields } from '../../config/calculator-student-loan-step-1-form-fields';
import { utilNumberToCurrency, utilStringToNumber } from '../../../../../../utils';

export const CalculatorStudentLoanStepperStep1: FunctionComponent<{ id: number }> = ({ id }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isValid }
  } = useForm({
    mode: 'onBlur',
    defaultValues: getDefaultValuesStep1()
  });

  const [completedText, setCompletedText] = useState('');
  const { updateForm } = useContext(FormContext);
  const { withPartner } = watch();

  const onSubmit = (data: Record<keyof CalculatorsStudentLoanStep1FormFields, string>) => {
    console.log(data);
    updateForm(data);
    const { studentDebtAmount, partnerStudentDebtAmount } = data;
    setCompletedText(
      utilNumberToCurrency(
        utilStringToNumber(studentDebtAmount) + utilStringToNumber(partnerStudentDebtAmount),
        true,
        0
      )
    );
  };

  return (
    <Fragment>
      <StepperHeader
        onClose={handleSubmit(onSubmit)}
        title="Je studieschuld"
        id={id}
        completedText={completedText}
      />
      <StepperContent>
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormElementDynamicInputTyped<CalculatorsStudentLoanStep1FormFields>
            formFields={calculatorStudentLoanStep1FormFields}
            id={'studentDebtAmount'}
            register={register}
            variant={`calculator`}
            errors={errors}
            values={watch()}
            options={{ required: true }}
          />
          <FormElementDynamicInputTyped<CalculatorsStudentLoanStep1FormFields>
            formFields={calculatorStudentLoanStep1FormFields}
            id={'withPartner'}
            register={register}
            errors={errors}
            values={watch()}
            options={{ required: true }}
          />
          {withPartner === 'true' && (
            <div className={`mt-2`}>
              <FormElementDynamicInputTyped<CalculatorsStudentLoanStep1FormFields>
                formFields={calculatorStudentLoanStep1FormFields}
                id={'partnerStudentDebtAmount'}
                register={register}
                errors={errors}
                values={watch()}
                options={{ required: true, optionalStyle: true }}
              />
            </div>
          )}
          <StepperSubmit id={id} isValidated={isValid} />
        </form>
      </StepperContent>
    </Fragment>
  );
};
